module.exports = __webpack_public_path__ + "img/view_device_c6s.609daad2.jpg";